import { Button, withStyles } from '@material-ui/core';

const styles = () => ({
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 16
  },
  button: {
    width: 86,
    height: 32
  }
});
const Footer = ({ classes, onClose }) => (
  <div className={classes.actionContainer}>
    <Button variant="outlined" color="primary" onClick={onClose} className={classes.button}>
      Close
    </Button>
  </div>
);

export default withStyles(styles)(Footer);
